import React from 'react'
import { Link } from 'react-router-dom'
import { useFormikContext } from 'formik'
import { withRouter } from 'react-router-dom'

const GetNavigationUrl = (clientId, nextStep) => {
    const routePath = clientId || 'new'
    return `/clients/${routePath}/${nextStep}`
}

/**
 * Recursive method to go through the object that is passed in and return the
 * keys in dot notation. Example:
 * {
 *  first: {
 *    second: 'value
 *  },
 *  third: {
 *    fourth: 'value
 *  }
 * }
 *
 * would return
 * [
 *  first.second,
 *  third.fourth
 * ]
 * @param {object of errors} inObject
 */
const GetNestedObjectKeys = (inObject) => {
    let rtnArray = []

    const keys = Object.keys(inObject)

    for (var i = 0; i < keys.length; i++) {
        const key = keys[i]
        if (typeof inObject[key] === 'object') {
            const nestedKeys = GetNestedObjectKeys(inObject[key])
            for (let j = 0; j < nestedKeys.length; j++) {
                const nestedKey = nestedKeys[j]
                rtnArray.push(`${key}.${nestedKey}`)
            }
        } else {
            rtnArray.push(key)
        }
    }

    return rtnArray
}

const FormNavigationButtons = ({ history, clientId, next, previous, section, onSave }) => {
    const {
        validateForm,
        setFieldError,
        setFieldTouched,
        values,
        // resetForm,
        setFieldValue,
        isValid,
        touched,
        // ...rest
    } = useFormikContext()

    const IsNew = clientId === 'new'

    const ClearSection = (e) => {
        e.preventDefault()

        const allFieldsKeys = GetNestedObjectKeys(values[section])
        for (let i = 0; i < allFieldsKeys.length; i++) {
            const key = allFieldsKeys[i]
            const fullKey = `${section}.${key}`
            setFieldValue(fullKey, '')
        }
    }

    function isTouched(obj) {
        return obj && Object.keys(obj).length !== 0
    }

    const NextClicked = (e) => {
        e.preventDefault()

        // validate the form and check if there are any errors in this section of the
        // form. If there are errors set them and touch the fields so that the error
        // message displays in the form.
        //
        // If there are no errors in the section then we will navigate to the next URL
        validateForm().then((errors) => {
            const sectionErrors = errors[section]
            if (!sectionErrors || Object.keys(sectionErrors).length === 0) {
                history.push(next)
            } else {
                const sectionErrorFields = GetNestedObjectKeys(sectionErrors)
                for (let i = 0; i < sectionErrorFields.length; i++) {
                    const key = sectionErrorFields[i]
                    const errorMessage = sectionErrors[key]
                    const fullKey = `${section}.${key}`
                    setFieldError(fullKey, errorMessage)
                    setFieldTouched(fullKey, errorMessage)
                }
            }
        })
    }

    return (
        <div className="form-nav client-buttons">
            <div>
                <button type="button" onClick={ClearSection} className="btn btn-left">
                    CLEAR
                </button>

                {onSave && (
                    <button
                        type="button"
                        onClick={() => {
                            if (isValid && isTouched(touched)) {
                                onSave(values)
                            }
                        }}
                        className={
                            isValid && isTouched(touched)
                                ? 'btn btn-left'
                                : 'btn btn-disabled btn-left'
                        }
                    >
                        SAVE
                    </button>
                )}
            </div>

            <div>
                {onSave && (
                    <input
                        type="submit"
                        value="PRESENT IPSA"
                        id="new-client-submit"
                        className={
                            isValid
                                ? 'btn arrow-btn btn-right'
                                : 'btn btn-disabled arrow-btn btn-right'
                        }
                    />
                )}
                {next && (
                    <Link
                        onClick={NextClicked}
                        to={GetNavigationUrl(clientId, next)}
                        className="btn arrow-btn btn-right"
                    >
                        NEXT
                    </Link>
                )}

                {previous && (
                    <Link
                        id="new-client-prev"
                        to={GetNavigationUrl(clientId, previous)}
                        className="btn arrow-btn arrow-btn-left btn-right"
                    >
                        PREV
                    </Link>
                )}
            </div>
        </div>
    )
}

export default withRouter(FormNavigationButtons)
